import React from "react"

const FormNavigator = ({formPage, setFormPage}) => {
    const handleClick = () => {
        const token = localStorage.getItem(`jwt`);
        if(formPage === 4) {
            setFormPage(0)
        }else if(formPage === 3 && token) {
            setFormPage(1)
        }
            else {
            setFormPage(formPage - 1)
        }
    }
    return (
        <div className="formNavigator">
            <div onClick={handleClick}> 
            ←
            </div>
        </div>
    )

}



export default FormNavigator